import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Button,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";
import { epcToEAN13, validateEAN13 } from "../../../../utils/ean13Generator";



function ComprasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_ARTICULOS = import.meta.env.VITE_URL_ARTICULOS;

  const URL_PROVEEDORES = import.meta.env.VITE_URL_PROVEEDORES;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const URL_SEND_MAIL = import.meta.env.VITE_URL_SEND_MAIL;
  const URL_WHATSAPP = import.meta.env.VITE_URL_WHATSAPP;
  const URL_COMPRAS = import.meta.env.VITE_URL_COMPRAS;
  const URL_ARTICULOS_PROPORCION =
    import.meta.env.VITE_URL_ARTICULOS_PROPORCION;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;
  const AREAS_GENERAL = import.meta.env.VITE_AREAS_GENERAL;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [idsArticulos, setIdsArticulos] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");

  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");

  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [fecha, setFecha] = useState(hoy);
  const [total_general, setTotalGeneral] = useState(0);
  const [subTotal, setSubTotal] = useState(0);

  const [total_cantidad, setTotalCantidad] = useState(0);
  const [codigoEscaneadoPrueba, setCodigoEscaneadoPrueba] = useState("");
  
  const [inputFields, setInputFields] = useState([
    // {
    //   id: uuidv4(),
    //   articulos: "",
    //   cantidad: 0,
    //   precio: 0,
    //   precioOriginal: 0,
    //   total: 0,
    //   articulosNombre: "",
    //   idColor: "",
    //   colorNombre: "",
    //   idTalla: "",
    //   tallaNombre: "",
    //   colores: [],
    //   tallas: [],
    // },
  ]);
  const [expandedTables, setExpandedTables] = useState({});

  const [manualInput, setManualInput] = useState({
    articulosNombre: "",
    articulos: "",
    idColor: "",
    idTalla: "",
    tallaNombre: "",
    cantidad: 0,
    precio: 0,
    colores: [],
    tallas: [],
    total: 0,
  });

  // Campo de escaneo QR/RFID NO controlado: el navegador acumula los caracteres
  // del lector sin que React reescriba el value entre teclas (ver VentasTiendasCreate).
  const rfidScanRef = useRef(null);
  // Lectura RFID masiva: cada tag (EPC) es UNA pieza fisica y se agrega sola.
  //  - epcLeidosRef: EPC -> celda (articulo|color|talla). Evita contar dos veces
  //    el mismo tag cuando el lector lo reporta varias veces.
  //  - proporcionCacheRef: codigo -> promesa de la proporcion, para no repetir la
  //    consulta al servidor por cada tag del mismo modelo/color/talla.
  const epcLeidosRef = useRef(new Map());
  const proporcionCacheRef = useRef(new Map());
  const [rfidStats, setRfidStats] = useState({
    leidas: 0,
    repetidas: 0,
    noEncontradas: 0,
  });
  const [proporcionScannerInput, setProporcionScannerInput] = useState("");

  const handleManualArticuloChange = (selectedArticulo) => {
    if (selectedArticulo) {
      setManualInput({
        articulos: selectedArticulo._id,
        articulosNombre: selectedArticulo.codigo + selectedArticulo.nombre,
        precio: selectedArticulo.costoMX,
        colores: selectedArticulo.colores,
        tallas: selectedArticulo.tallas,
        idColor: "",
        idTalla: "",
        cantidad: 0,
        idProporcion: "",
      });
    }
  };

  const ActualizaTotales = useCallback(() => {
    let totalKG = inputFields.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TK);
    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);

    setTotalGeneral(TG);
  }, [inputFields, setTotalCantidad, setSubTotal, setTotalGeneral]);

  useEffect(() => {
    ActualizaTotales();
  }, [inputFields, ActualizaTotales]);

  const handleManualInputChange = (event) => {
    const { name, value } = event.target;

    setManualInput((prev) => {
      const updatedInput = {
        ...prev,
        [name]: value,
      };

      // If changing talla, update tallaNombre
      if (name === "idTalla") {
        const selectedTalla = prev.tallas.find((t) => t._id === value);
        updatedInput.tallaNombre = selectedTalla ? selectedTalla.name : "";
      }

      // Calculate total whenever cantidad changes
      if (name === "cantidad") {
        updatedInput.cantidad = parseFloat(value);
        updatedInput.total = parseFloat(value) * prev.precio;
      }

      return updatedInput;
    });
  };

  const handleManualAdd = async () => {
    if (
      !manualInput.articulosNombre ||
      !manualInput.idColor ||
      !manualInput.idTalla ||
      !manualInput.cantidad
    ) {
      return;
    }

    // Candado de doble clic: sin el, dos clics rapidos creaban dos renglones
    // para el mismo combo (el chequeo de duplicados leia estado stale) y el
    // grid solo mostraba uno.
    if (agregandoRef.current) return;
    agregandoRef.current = true;

    try {
      let res;

      try {
        res = await axios.get(
          `${URL_ARTICULOS_PROPORCION}/ArticuloColorTalla/${manualInput.articulos}/${manualInput.idColor}/${manualInput.idTalla}`,
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
      } catch (err) {
        console.log(err);
      }

      if (!res) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se encontró el artículo con la talla y color seleccionados",
          showConfirmButton: false,
        });
        return;
      }
      const idArticuloProporcion = res.data[0]._id;

      const cantidadNueva = parseFloat(manualInput.cantidad) || 0;
      const selectedColor = manualInput.colores.find(
        (c) => c._id === manualInput.idColor
      );
      const selectedTalla = manualInput.tallas.find(
        (t) => t._id === manualInput.idTalla
      );

      const newField = {
        id: uuidv4(),
        articulos: manualInput.articulos,
        articulosNombre: manualInput.articulosNombre,
        precio: manualInput.precio,
        cantidad: cantidadNueva,
        idTalla: manualInput.idTalla,
        tallaNombre: selectedTalla ? selectedTalla.name : "",
        idColor: manualInput.idColor,
        colorNombre: selectedColor ? selectedColor.name : "",
        total: cantidadNueva * manualInput.precio,
        colores: manualInput.colores,
        tallas: manualInput.tallas,
        idArticuloProporcion: idArticuloProporcion,
      };

      // Decidir con estado FRESCO (dentro del updater) si se fusiona con un
      // renglon existente o se agrega uno nuevo. La identidad es la celda del
      // grid: articulo + color + NOMBRE de talla (hay tallas duplicadas con
      // distinto _id y mismo nombre, y registros de proporcion repetidos);
      // dos renglones de la misma celda se pintan uno encima del otro y uno
      // quedaria invisible pero se guardaria.
      const tallaNombreNueva = selectedTalla ? selectedTalla.name : "";
      setInputFields((prev) => {
        const idx = prev.findIndex(
          (i) =>
            i.articulos === manualInput.articulos &&
            i.idColor === manualInput.idColor &&
            i.tallaNombre === tallaNombreNueva
        );
        if (idx >= 0) {
          return prev.map((field, j) => {
            if (j !== idx) return field;
            const cantidad = (parseFloat(field.cantidad) || 0) + cantidadNueva;
            return { ...field, cantidad, total: cantidad * field.precio };
          });
        }
        return [...prev, newField];
      });

      // Reset only specific fields after adding
      setManualInput((prev) => ({
        ...prev,
        idColor: "",
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        idTalla: "",
        tallaNombre: "",
        precio: 0,
        total: 0,
        idProporcion: "",
      }));
    } finally {
      agregandoRef.current = false;
    }
  };

  const [inputArticulos, setInputArticulos] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cajas: 0,
      precio: 0,
      articulosNombre: "",
      colores: [],
      tallas: [],
      EAN: "",
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);
  const submittingRef = useRef(false);

  // Borrador automatico: guarda el avance en localStorage para que no se
  // pierda si se cierra el navegador o se sale accidentalmente de la pestaña
  // (mismo patron que TraspasosSalidaCreate.jsx).
  const DRAFT_KEY = `entrada_tienda_${user._id}`;
  const restoredRef = useRef(false);
  const canSaveRef = useRef(false);
  // Candado de doble clic para los flujos que AGREGAN renglones (proporcion y
  // pieza manual): dos clics rapidos pasaban ambos el chequeo de duplicados
  // (leia estado desactualizado) y duplicaban filas que el grid no muestra
  // pero si se guardan.
  const agregandoRef = useRef(false);
  const [cambiarPrecio, setCambiarPrecio] = useState(false);

  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);
  const [password, setPassword] = useState("");

  const [mailAutEnviado, setMailAutEnviado] = useState(false);
  const [randomCambiaPrecio, setRandomCambiaPrecio] = useState(
    (Math.random() + 1).toString(36).substring(2)
  );

  useEffect(() => {
    if (user && user.areas !== undefined && user.areas !== AREAS_GENERAL) {
      setSelectedArea(user.areas);
    }
  }, [user]);

  useMemo(() => {
    axios
      .get(`${URL_ARTICULOS}Activos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
        let result = allArticulos.map((a) => a._id);
        setIdsArticulos(result);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
        const customeSizeOrder = allTallas.map((t) => t.name);
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // Restaura el borrador guardado (si existe) al montar la pantalla.
  useEffect(() => {
    if (restoredRef.current) return;
    restoredRef.current = true;

    let draft = null;
    try {
      const saved = localStorage.getItem(DRAFT_KEY);
      if (saved) draft = JSON.parse(saved);
    } catch (e) {
      console.log("Error al leer borrador", e);
    }

    const tieneAvance =
      draft &&
      ((draft.inputFields && draft.inputFields.length > 0) || draft.selectedArea);

    if (!tieneAvance) {
      canSaveRef.current = true;
      return;
    }

    Swal.fire({
      title: "Entrada sin terminar",
      text: "Tienes una entrada de mercancía en progreso. ¿Deseas continuar con ella o empezar una nueva?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Continuar con la anterior",
      cancelButtonText: "Empezar una nueva",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
      allowOutsideClick: false,
      allowEscapeKey: false,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        if (draft.fecha) setFecha(draft.fecha);
        if (draft.selectedArea) setSelectedArea(draft.selectedArea);
        if (draft.selectedProveedor) setSelectedProveedor(draft.selectedProveedor);
        if (Array.isArray(draft.epcs)) {
          epcLeidosRef.current = new Map(draft.epcs);
        }
        if (draft.inputFields) setInputFields(draft.inputFields);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        localStorage.removeItem(DRAFT_KEY);
      }
      canSaveRef.current = true;
    });
  }, []);

  // Guarda el borrador cada vez que cambia el avance (despues de decidir).
  useEffect(() => {
    if (!canSaveRef.current) return;
    try {
      const hayAvance =
        inputFields.some((f) => f.articulos || parseFloat(f.cantidad) > 0) ||
        (selectedArea && selectedArea !== "");
      if (hayAvance) {
        localStorage.setItem(
          DRAFT_KEY,
          JSON.stringify({
            fecha,
            selectedArea,
            selectedProveedor,
            inputFields,
            epcs: Array.from(epcLeidosRef.current.entries()),
          })
        );
      } else {
        localStorage.removeItem(DRAFT_KEY);
      }
    } catch (e) {
      console.log("Error al guardar borrador", e);
    }
  }, [fecha, selectedArea, selectedProveedor, inputFields]);

  const savePedido = async (event) => {
    try {
      event.preventDefault();
      if (submittingRef.current) return;
      submittingRef.current = true;
      setValidaBoton(false);

      if (!selectedArea) {
        Swal.fire({
          icon: "warning",
          title: "Área requerida",
          text: "Por favor selecciona un área antes de guardar",
        });
        submittingRef.current = false;
        setValidaBoton(true);
        return;
      }

      if (!selectedProveedor) {
        Swal.fire({
          icon: "warning",
          title: "Proveedor requerido",
          text: "Por favor selecciona un proveedor antes de guardar",
        });
        submittingRef.current = false;
        setValidaBoton(true);
        return;
      }

      // Filter out empty items
      const validItems = inputFields.filter(
        (a) => a.articulos !== "" && parseFloat(a.cantidad) > 0
      );

      if (validItems.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "Sin artículos",
          text: "No hay artículos con cantidad para guardar.",
        });
        submittingRef.current = false;
        setValidaBoton(true);
        return;
      }

      // Blindaje: dos renglones que caen en la MISMA celda del grid (mismo
      // articulo + color + NOMBRE de talla; hay tallas duplicadas con distinto
      // _id y mismo nombre) se pintan uno encima del otro: uno queda invisible
      // pero ambos se guardan. Si algun flujo llegara a producirlos, frenar
      // aqui y avisar en lugar de guardar piezas que no se ven.
      const combosVistos = new Set();
      const combosDuplicados = [];
      for (const a of validItems) {
        const combo = `${a.articulos}|${a.idColor}|${a.tallaNombre}`;
        if (combosVistos.has(combo)) {
          combosDuplicados.push(`${a.articulosNombre} ${a.colorNombre} ${a.tallaNombre}`);
        }
        combosVistos.add(combo);
      }
      if (combosDuplicados.length > 0) {
        Swal.fire({
          icon: "error",
          title: "Renglones duplicados detectados",
          html:
            `Hay más de un renglón para:<br/><b>${combosDuplicados.join("<br/>")}</b><br/><br/>` +
            `Elimina el artículo de la lista y vuélvelo a agregar antes de guardar.`,
        });
        submittingRef.current = false;
        setValidaBoton(true);
        return;
      }

      // Totales calculados de los renglones que realmente se van a guardar,
      // para que el resumen, el total enviado y los renglones sean lo mismo.
      const totalPiezas = validItems.reduce(
        (t, a) => t + (parseFloat(a.cantidad) || 0),
        0
      );
      const totalCosto = validItems.reduce(
        (t, a) => t + (parseFloat(a.cantidad) || 0) * (parseFloat(a.precio) || 0),
        0
      );

      // Resumen por articulo para cotejar contra el packing list ANTES de
      // guardar: si el total no cuadra con la lista, aqui es donde se detiene.
      const piezasPorArticulo = {};
      for (const a of validItems) {
        piezasPorArticulo[a.articulosNombre] =
          (piezasPorArticulo[a.articulosNombre] || 0) + (parseFloat(a.cantidad) || 0);
      }
      const filasResumen = Object.entries(piezasPorArticulo)
        .map(
          ([nombre, piezas]) =>
            `<tr><td style="text-align:left;padding:2px 8px">${nombre}</td>` +
            `<td style="text-align:right;padding:2px 8px"><b>${new Intl.NumberFormat("en-US").format(piezas)}</b></td></tr>`
        )
        .join("");
      const confirmResumen = await Swal.fire({
        title: "Confirmar entrada",
        html:
          `<div style="max-height:300px;overflow-y:auto"><table style="width:100%;font-size:14px">${filasResumen}</table></div>` +
          `<hr/><b>Total: ${new Intl.NumberFormat("en-US").format(totalPiezas)} piezas &nbsp;/&nbsp; $${new Intl.NumberFormat("en-US").format(totalCosto)}</b>` +
          `<br/><br/>Compara las piezas contra tu lista antes de guardar.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, guardar!",
        cancelButtonText: "Cancelar",
      });
      if (!confirmResumen.isConfirmed) {
        submittingRef.current = false;
        setValidaBoton(true);
        return;
      }

      // Make a single API call with all data
      const response = await axios.post(
        `${URL_COMPRAS}Batch`,
        {
          fecha,
          total_cantidad: totalPiezas,
          total_costo: totalCosto,
          user: user.id,
          areas: selectedArea,
          proveedores: selectedProveedor, // Note: backend uses provedoor
          // Send all items in a single request
          items: validItems.map((a) => ({
            articulos: a.articulos,
            cantidad: parseFloat(a.cantidad),
            colores: a.idColor,
            tallas: a.idTalla,
            costoPieza: a.precio,
            articulosProporcion: a.idArticuloProporcion,
            ubicacion: a.ubicacion || "Almacen",
          })),
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      // Create a single log entry for the entire purchase
      await axios.post(
        URL_LOGS,
        {
          tipo: "Compra",
          detalle: `Compra completada - ${validItems.length} artículos, total: ${totalPiezas}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      // Entrada guardada correctamente: limpia el borrador.
      localStorage.removeItem(DRAFT_KEY);
      Swal.fire("Good job!", "Actualizado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);

      // Handle success - can display notification or redirect
      console.log("Purchase saved successfully:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error saving purchase:", error);
      submittingRef.current = false;
      setValidaBoton(true);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Algo salio mal",
      });
      // Handle error - display notification to user
      throw error;
    }
  };

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        precio: 0,
        total: 0,
        articulosNombre: "",
        idColor: "",
        colorNombre: "",
        idTalla: "",
        tallaNombre: "",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const eliminado = inputFields.find((value) => value.id === id);
    if (eliminado) {
      const celda = `${eliminado.articulos}|${eliminado.idColor}|${eliminado.tallaNombre}`;
      epcLeidosRef.current.forEach((v, k) => {
        if (v === celda) epcLeidosRef.current.delete(k);
      });
    }
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let totalCan = values.map((c) => parseFloat(c.cantidad));
    let TC = totalCan.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    setTotalGeneral(TG);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputPrecio = (id, event) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        i.precio = event.target.value;
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
    ActualizaTotales();
  };

  function BuscaCodigoProporcion(id, event) {
    const scanValue = event.target.value.toUpperCase();

    // Only validate that scan value exists
    if (!scanValue) {
      return;
    }

    const foundArticle = articulos.find((a) => a.EAN?.toUpperCase() === scanValue);

    if (foundArticle) {
      const idArticulo = foundArticle._id;
      const articulosNombre = `${foundArticle.codigo} ${foundArticle.nombre}`;
      const colores = foundArticle.colores;
      const tallas = foundArticle.tallas;
      const precio = foundArticle.costoMX;

      handleChangeInputArticuloProporcion(
        id,
        idArticulo,
        precio,
        articulosNombre,
        colores,
        tallas,
        scanValue
      );

      // Clear the proporcion scanner input after successful scan
      setProporcionScannerInput("");
    } else {
      Swal.fire({
        icon: "error",
        title: "Artículo no encontrado",
        text: "No se encontró ningún artículo con el código proporcionado",
      });
      // Also clear the input on error so user can try again
      setProporcionScannerInput("");
    }
  }

  const handleChangeInputCantidad = (id, event) => {
    // Guardar SIEMPRE numero: si la cantidad queda como string, los flujos que
    // suman cantidades concatenan texto ("48" + 4 = "484").
    const num = parseFloat(event.target.value);
    const cantidad = isNaN(num) ? 0 : num;
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cantidad = cantidad;
        i.total = cantidad * i.precio;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputArticulo = (
    id,
    idArticulo,
    piezasPorCaja,
    precio,
    articulosNombre,
    colores,
    tallas
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.piezasPorCaja = piezasPorCaja;
        i.precio = precio;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.articulosNombre = articulosNombre;
        i.colores = colores;
        i.tallas = tallas;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
    handleAddFields();
  };

  const options = articulos.map((option) => {
    const junta = option.codigo;
    const firstLetter = option.codigo[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  const options2 = areas.map((option) => {
    const junta = option.name;
    const firstLetter = option.name[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  function autorizaCambio() {
    if (password === randomCambiaPrecio) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
      Swal.fire("Good job!", "Se autorizo con exito", "success");
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }

  function solicitarAut() {
    setMailAutEnviado(true);

    axios.post(
      `${URL_WHATSAPP}SendMsg`,
      {
        number: import.meta.env.VITE_TELEFONO_SUPER_ADMIN,
        message: `Hola,
El Vendedor ${user.nombre} ${user.apellido} esta solicitando un cambio de precio.
Si lo autorizas proporciona la clave:
${randomCambiaPrecio}`,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    axios
      .post(
        URL_SEND_MAIL,
        {
          subject: "Cambio de Precio",
          email: import.meta.env.VITE_EMAIL_SUPER_ADMIN,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
       <th><img width="${import.meta.env.VITE_TAMANO_LOGO_MAIL}" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}logoInstitucion.png" /></th>
       <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${import.meta.env.VITE_NOMBRE_INSTITUCION}</tr>
       <tbody>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>El vendedor ${user.nombre} ${user.apellido} esta solicitando un cambio de precio, si lo autorizas proporciona la clave ${randomCambiaPrecio}</tr>
       </tbody>
       <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${import.meta.env.VITE_TELEFONO_INSTITUCION}</tr>
       <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}Logo-Sistemify-PDF.png" /> </a> </tr>
       </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  const handleChangeInputProporcion = (id, event) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
  };

  function BuscaArticuloProporcion(id, selectedArticulo) {
    const foundArticle = articulos.find((a) => a._id === selectedArticulo._id);

    if (foundArticle) {
      const idArticulo = selectedArticulo._id;
      const articulosNombre = `${selectedArticulo.codigo} ${selectedArticulo.nombre}`;
      const colores = foundArticle.colores;
      const tallas = foundArticle.tallas;
      const precio = foundArticle.costoMX;
      const EAN = foundArticle.EAN;

      handleChangeInputArticuloProporcion(
        id,
        idArticulo,
        precio,
        articulosNombre,
        colores,
        tallas,
        EAN
      );
    } else {
      Swal.fire({
        icon: "error",
        title: "Artículo no encontrado",
        text: "No se encontró ningún artículo con el código proporcionado",
      });
    }
  }
  // Aviso NO bloqueante: un modal le quita el foco al campo y las lecturas
  // siguientes del lector se pierden. El toast de SweetAlert no roba el foco.
  const avisoRFID = (icon, title) =>
    Swal.fire({
      toast: true,
      position: "top-end",
      icon,
      title,
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });

  // Busca la proporcion por RFID (EAN-13) y, si no aparece, por EAN (QR clasico).
  // Cachea la promesa por codigo para no repetir la consulta en lecturas masivas.
  function buscarProporcionPorCodigo(scanned) {
    const scanValue = scanned.toUpperCase();
    const cache = proporcionCacheRef.current;
    if (cache.has(scanValue)) return cache.get(scanValue);

    const headers = {
      Authorization: `Bearer ${localStorage.getItem("app_token")}`,
    };
    const promesa = (async () => {
      let res = null;
      let viaRFID = false;
      if (validateEAN13(scanned)) {
        res = await axios
          .get(`${URL_ARTICULOS_PROPORCION}/RFID/${scanValue}`, { headers })
          .catch(() => null);
        viaRFID = !!(res && res.data);
      }
      if (!res || !res.data) {
        res = await axios
          .get(`${URL_ARTICULOS_PROPORCION}/EAN/${scanValue}`, { headers })
          .catch(() => null);
      }
      const data = res && res.data;
      if (
        !data ||
        !data.articulos?.[0] ||
        !data.colores?.length ||
        !data.tallas?.length
      ) {
        return null;
      }
      // viaRFID: el codigo coincidio con el RFID de la etiqueta (= una pieza)
      return { ...data, viaRFID };
    })();
    cache.set(scanValue, promesa);
    // No dejar cacheado un "no encontrado": pudo ser un error de red temporal.
    promesa.then((d) => {
      if (!d) cache.delete(scanValue);
    });
    return promesa;
  }

  // Punto de entrada del campo de escaneo. Recibe el TEXTO ya capturado (no el
  // evento): el campo se limpia de forma sincrona ANTES de cualquier await para
  // que el siguiente escaneo caiga en un campo vacio. Si el lector pego varios
  // EPC sin separador (48, 72... hex) se procesan uno por uno.
  function buscarArticuloSingular(id, rawInput) {
    const raw = (rawInput || "").trim();
    if (!raw) return;

    const hex = raw.replace(/\s+/g, "").toUpperCase();
    if (hex.length > 24 && hex.length % 24 === 0 && /^[0-9A-F]+$/.test(hex)) {
      for (let i = 0; i < hex.length; i += 24) {
        procesarCodigoEscaneado(hex.substring(i, i + 24));
      }
      return;
    }
    procesarCodigoEscaneado(raw);
  }

  async function procesarCodigoEscaneado(raw) {
    setCodigoEscaneadoPrueba(raw);

    // El lector RFID entrega un EPC SGTIN-96 (24 hex). Lo convertimos a EAN-13.
    const epcDecoded = epcToEAN13(raw);
    const esTagRFID = !!epcDecoded;
    const epc = raw.replace(/\s+/g, "").toUpperCase();
    const scanned = epcDecoded || raw;
    // Lectura de etiqueta: EPC hexadecimal o su EAN-13 ya decodificado por el
    // lector (13 digitos). En ambos casos los avisos deben ser no bloqueantes.
    const esLecturaEtiqueta = esTagRFID || validateEAN13(scanned);

    if (esTagRFID) {
      // Mismo tag fisico ya contado (o en proceso): no sumar otra pieza.
      if (epcLeidosRef.current.has(epc)) {
        setRfidStats((st) => ({ ...st, repetidas: st.repetidas + 1 }));
        return;
      }
      // Reservar el EPC ANTES del await para bloquear lecturas duplicadas en vuelo
      epcLeidosRef.current.set(epc, "");
    }

    const data = await buscarProporcionPorCodigo(scanned);

    if (!data) {
      if (esLecturaEtiqueta) {
        if (esTagRFID) epcLeidosRef.current.delete(epc);
        setRfidStats((st) => ({ ...st, noEncontradas: st.noEncontradas + 1 }));
        avisoRFID("error", `Tag no encontrado: ${scanned}`);
      } else {
        Swal.fire({
          icon: "error",
          title: "Artículo no encontrado",
          text: "No se encontró ningún artículo con el código proporcionado",
        }).then(() => {
          // Regresa el foco al campo para seguir escaneando
          if (rfidScanRef.current) rfidScanRef.current.focus();
        });
      }
      return;
    }

    const {
      _id: idArticuloProporcion,
      articulos: [firstArticulo],
      colores,
      tallas,
    } = data;
    const articulosNombre = `${firstArticulo.codigo} ${firstArticulo.nombre}`;

    // Es UNA pieza fisica si vino el EPC del tag o si el EAN-13 leido coincide con
    // el RFID de la etiqueta (el lector puede entregar cualquiera de los dos).
    const esPieza = esTagRFID || data.viaRFID;

    if (!esPieza) {
      // QR de proporcion: se conserva el flujo manual (llena el renglon para
      // capturar la cantidad y dar clic en Agregar).
      setManualInput({
        articulos: firstArticulo._id,
        articulosNombre,
        precio: firstArticulo.costoMX,
        colores: colores,
        tallas: tallas,
        idColor: colores[0]._id,
        idTalla: tallas[0]._id,
        cantidad: 1,
        idProporcion: idArticuloProporcion,
      });
      return;
    }

    // Tag RFID = 1 pieza: se agrega directo. La identidad es la celda del grid
    // (articulo + color + NOMBRE de talla), igual que en handleManualAdd, y se
    // decide con estado FRESCO dentro del updater (hay lecturas concurrentes).
    const precio = parseFloat(firstArticulo.costoMX) || 0;
    const idColor = colores[0]._id;
    const tallaNombre = tallas[0].name;
    // Solo el EPC trae numero de serie: con EAN-13 no se puede distinguir un tag
    // repetido de otra pieza igual, asi que cada lectura suma.
    if (esTagRFID) {
      epcLeidosRef.current.set(epc, `${firstArticulo._id}|${idColor}|${tallaNombre}`);
    }

    setInputFields((prev) => {
      const idx = prev.findIndex(
        (i) =>
          i.articulos === firstArticulo._id &&
          i.idColor === idColor &&
          i.tallaNombre === tallaNombre
      );
      if (idx >= 0) {
        return prev.map((field, j) => {
          if (j !== idx) return field;
          const cantidad = (parseFloat(field.cantidad) || 0) + 1;
          return { ...field, cantidad, total: cantidad * field.precio };
        });
      }
      return [
        ...prev,
        {
          id: uuidv4(),
          articulos: firstArticulo._id,
          articulosNombre,
          precio,
          cantidad: 1,
          idTalla: tallas[0]._id,
          tallaNombre,
          idColor,
          colorNombre: colores[0].name,
          total: precio,
          colores: colores,
          tallas: tallas,
          idArticuloProporcion: idArticuloProporcion,
        },
      ];
    });
    setRfidStats((st) => ({ ...st, leidas: st.leidas + 1 }));
  }

  const handleChangeInputArticuloProporcion = (
    id,
    idArticulo,
    precio,
    articulosNombre,
    colores,
    tallas,
    ean
  ) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.precio = precio;
        i.articulosNombre = articulosNombre;
        i.cajas = 0;
        i.colores = colores;
        i.tallas = tallas;
        i.EAN = ean;
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
    ActualizaTotales();
  };

  function agregarProporcion(
    idArticulo,
    articulosNombre,
    precio,
    cajas,
    colores,
    tallas
  ) {
    if (agregandoRef.current) return;
    agregandoRef.current = true;
    axios
      .get(`${URL_ARTICULOS_PROPORCION}Articulos/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;

        const avaible = inputFields.find((f) => f.articulos === idArticulo);
        if (avaible) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Ya existe este articulo en la lista",
            showConfirmButton: false,
          });
          return;
        }

        // Fusionar registros de proporcion que caen en la MISMA celda del grid
        // (mismo color + mismo NOMBRE de talla). El catalogo tiene combos
        // repetidos, incluso con tallas de _id distinto pero mismo nombre
        // (hay tallas duplicadas: dos "SM", dos "24", etc.); el grid pinta las
        // celdas por nombre, asi que sin fusion se crean dos filas y solo una
        // se ve: la otra se guarda sin verse (piezas fantasma, caso HSL5726BL
        // PURPLE SM de la compra del 2026-08-25).
        const porCombo = new Map();
        const registrosFusionados = [];
        for (const i of allArticulos) {
          const combo = `${i.colores[0]._id}|${i.tallas[0].name}`;
          const cant = parseFloat(i.cantidad) || 0;
          const previo = porCombo.get(combo);
          if (previo) {
            // Referenciar el registro con cantidad real, no el de 0.
            if (previo.cantidadPorCaja === 0 && cant > 0) previo.registro = i;
            previo.cantidadPorCaja += cant;
          } else {
            const nuevo = { registro: i, cantidadPorCaja: cant };
            porCombo.set(combo, nuevo);
            registrosFusionados.push(nuevo);
          }
        }

        const cajasNum = parseFloat(cajas) || 0;
        const newInputFields = registrosFusionados.map(({ registro: i, cantidadPorCaja }) => {
          return {
            id: uuidv4(),
            articulos: idArticulo,
            articulosNombre: articulosNombre,
            precio: precio,
            cantidad: cajasNum * cantidadPorCaja,
            idTalla: i.tallas[0]._id,
            tallaNombre: i.tallas[0].name,
            idColor: i.colores[0]._id,
            colorNombre: i.colores[0].name,
            total: cajasNum * cantidadPorCaja * precio,
            colores: colores,
            tallas: tallas,
            idArticuloProporcion: i._id,
            // Add a groupKey to help with visual grouping
            groupKey: `${articulosNombre}-${i.colores[0].name}`,
            isFirstInGroup: false, // We'll set this after sorting
          };
        });

        setInputFields((prevInputFields) => {
          // Chequeo con estado FRESCO (no el closure): si otro clic ya metio
          // este articulo, no duplicar.
          if (prevInputFields.some((f) => f.articulos === idArticulo)) {
            return prevInputFields;
          }
          const updatedInputFields = [...prevInputFields, ...newInputFields];

          // Sort using your existing order
          const sortedInputFields = updatedInputFields.sort((a, b) => {
            if (a.articulosNombre < b.articulosNombre) return -1;
            if (a.articulosNombre > b.articulosNombre) return 1;

            if (a.colorNombre < b.colorNombre) return -1;
            if (a.colorNombre > b.colorNombre) return 1;

            return (
              customSizeOrder.indexOf(a.tallaNombre) -
              customSizeOrder.indexOf(b.tallaNombre)
            );
          });

          // Mark first items in each group
          let currentGroup = "";
          sortedInputFields.forEach((field, index) => {
            if (field.groupKey !== currentGroup) {
              field.isFirstInGroup = true;
              currentGroup = field.groupKey;
            } else {
              field.isFirstInGroup = false;
            }
          });

          // Calculate totals
          const totalCantidad = sortedInputFields.reduce(
            (acc, curr) => acc + parseFloat(curr.cantidad),
            0
          );
          setTotalCantidad(totalCantidad);

          let importes = sortedInputFields.map((c) => parseFloat(c.total));
          let TG = importes.reduce((t, total) => t + total, 0);

          setTotalGeneral(TG);

          return sortedInputFields;
        });

        setInputArticulos([
          {
            id: uuidv4(),
            articulos: "",
            cajas: 0,
            precio: 0,
            articulosNombre: "",
            colores: [],
            tallas: [],
            EAN: "",
          },
        ]);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        agregandoRef.current = false;
      });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pedidos_create || user.entradasTiendas ? (
        <div className="card container col-12 p-4">
          <h3 align="center">Nueva Entrada</h3>
          {/* <Form > */}
          <Row>
            <Col md={2}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                onChange={(e) => setFecha(e.target.value)}
                required
              />
            </Col>
            <Col md={2}>
              <Label>Almacen Destino</Label>
              {user.areas == AREAS_GENERAL ? (
                <Input
                  type="select"
                  value={selectedArea}
                  onChange={(e) => {
                    setSelectedArea(e.target.value);
                  }}
                >
                  <option value="">Selecciona un Almacen</option>
                  {areas
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              ) : (
                <Input
                  type="select"
                  value={selectedArea}
                  disabled
                  onChange={(e) => {
                    setSelectedArea(e.target.value);
                  }}
                >
                  <option value="">Selecciona un Almacen</option>
                  {areas
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      if (user.areas == a._id) {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              )}
            </Col>
            <Col md={2}>
              <Label>Proveedor</Label>
              <Input
                type="select"
                value={selectedProveedor}
                onChange={(e) => {
                  setSelectedProveedor(e.target.value);
                }}
              >
                <option value="">Selecciona un Proveedor</option>
                {proveedores
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((p) => {
                    return <option value={p._id}>{p.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
          </Row>
          <br />
          <br />

          {/* FULL PRODUCT SECTION */}
          <h4 className="text-dark">
            <b>Agregar Caja</b>
          </h4>
          <>
            {/* QR Scanner Input */}
            <Row className=""></Row>

            {/* Proportion Input Section */}
            <Row className="">
              <Col md={2}>
                <Label className="mr-sm-2">Escanea el QR</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Selecciona</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cajas</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio MEX</Label>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={2}>
                <Input
                  name="articulos"
                  type="string"
                  value={proporcionScannerInput} // Use the new proporcion scanner state
                  onChange={(event) =>
                    setProporcionScannerInput(event.target.value)
                  } // Update proporcion scanner state on change
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      BuscaCodigoProporcion(inputArticulos[0].id, event);
                    }
                  }}
                ></Input>
              </Col>
              <Col md={2}>
                <Autocomplete
                  size="small"
                  value={inputArticulos[0]?.articulosNombre || ""}
                  onChange={(event, selectedArticulo) => {
                    BuscaArticuloProporcion(
                      inputArticulos[0]?.id || "template",
                      selectedArticulo
                    );
                  }}
                  options={options.sort(
                    (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                  )}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option?.junta || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecciona"
                      variant="outlined"
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option._id}>
                      {option.codigo} {option.nombre}
                    </li>
                  )}
                />
              </Col>
              <Col md={2}>
                <Input
                  name="articulosNombre"
                  type="string"
                  placeholder="Articulo"
                  value={inputArticulos[0]?.articulosNombre || ""}
                  disabled
                />
              </Col>
              <Col md={1}>
                <Input
                  name="cajas"
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Cajas"
                  value={inputArticulos[0]?.cajas || ""}
                  required
                  onChange={(event) =>
                    handleChangeInputProporcion(
                      inputArticulos[0]?.id || "template",
                      event
                    )
                  }
                />
              </Col>
              <Col md={1}>
                <Input
                  name="precio"
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Precio"
                  value={inputArticulos[0]?.precio || ""}
                  required
                  onChange={(event) =>
                    handleChangeInputPrecio(
                      inputArticulos[0]?.id || "template",
                      event
                    )
                  }
                />
              </Col>
              <Col>
                <Button
                  size="sm"
                  className="btn"
                  color="success"
                  disabled={
                    !inputArticulos[0]?.articulos ||
                    !inputArticulos[0]?.cajas ||
                    !inputArticulos[0]?.precio
                  }
                  onClick={() =>
                    agregarProporcion(
                      inputArticulos[0]?.articulos,
                      inputArticulos[0]?.articulosNombre,
                      inputArticulos[0]?.precio,
                      inputArticulos[0]?.cajas,
                      inputArticulos[0]?.colores,
                      inputArticulos[0]?.tallas
                    )
                  }
                  tabindex="-1"
                >
                  Agregar
                </Button>
              </Col>
            </Row>

            {/* MANUAL PRODUCT SECTION */}
            <h4 className="text-dark">
              <b>Agregar Pieza</b>
            </h4>
            <Row className="">
              <Col md={2}>
                <Label className="mr-sm-2">
                  Escanea QR / RFID {codigoEscaneadoPrueba}
                </Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Selecciona</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Talla</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio MEX</Label>
              </Col>
            </Row>

            <Row>
              <Col md={2}>
                <Input
                  name="articulos"
                  type="text"
                  autoComplete="off"
                  innerRef={rfidScanRef}
                  onChange={(event) => {
                    // EPC RFID completo (24 hex, cabecera 30): se procesa de
                    // inmediato, sin depender de que el lector mande Enter.
                    const inputEl = event.target;
                    const hex = inputEl.value.replace(/\s+/g, "").toUpperCase();
                    if (/^30[0-9A-F]{22}$/.test(hex)) {
                      inputEl.value = "";
                      buscarArticuloSingular(manualInput.id, hex);
                    }
                  }}
                  onKeyDown={(event) => {
                    // Enter o Tab (segun el sufijo configurado en el lector)
                    if (
                      event.key === "Enter" ||
                      (event.key === "Tab" && event.target.value.trim())
                    ) {
                      event.preventDefault();
                      const inputEl = event.target;
                      const raw = inputEl.value;
                      // Limpiar AHORA (sincrono), antes de cualquier await,
                      // para que el siguiente escaneo caiga en un campo vacio.
                      inputEl.value = "";
                      buscarArticuloSingular(manualInput.id, raw);
                    }
                  }}
                ></Input>
                {(rfidStats.leidas > 0 ||
                  rfidStats.repetidas > 0 ||
                  rfidStats.noEncontradas > 0) && (
                  <small className="text-muted d-block">
                    RFID: {rfidStats.leidas} leídas · {rfidStats.repetidas}{" "}
                    repetidas · {rfidStats.noEncontradas} no encontradas
                  </small>
                )}
              </Col>
              <Col md={2}>
                <Autocomplete
                  size="small"
                  value={manualInput?.articulosNombre || ""}
                  onChange={(event, selectedArticulo) => {
                    handleManualArticuloChange(selectedArticulo);
                  }}
                  options={options.sort(
                    (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                  )}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option?.junta || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecciona"
                      variant="outlined"
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option._id}>
                      {option.codigo} {option.nombre}
                    </li>
                  )}
                />
              </Col>
              <Col md={2}>
                <Input
                  type="text"
                  value={manualInput?.articulosNombre || ""}
                  disabled
                />
              </Col>
              <Col md={1}>
                <Input
                  name="idColor"
                  type="select"
                  value={manualInput?.idColor || ""}
                  onChange={handleManualInputChange}
                >
                  <option value="">Selecciona Color</option>
                  {manualInput?.colores?.map((color) => (
                    <option key={color._id} value={color._id}>
                      {color.name}
                    </option>
                  ))}
                </Input>
              </Col>
              <Col md={1}>
                <Input
                  name="idTalla"
                  type="select"
                  value={manualInput.idTalla || ""}
                  onChange={handleManualInputChange}
                >
                  <option value="">Selecciona Talla</option>
                  {manualInput.tallas &&
                    manualInput.tallas.map((talla) => (
                      <option key={talla._id} value={talla._id}>
                        {talla.name}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={1}>
                <Input
                  name="cantidad"
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Cantidad"
                  value={manualInput?.cantidad || 0}
                  disabled={!manualInput?.idColor || !manualInput?.idTalla}
                  onChange={handleManualInputChange}
                />
              </Col>
              <Col md={1}>
                <Input
                  name="precio"
                  type="number"
                  value={manualInput?.precio || 0}
                  onChange={handleManualInputChange}
                />
              </Col>
              <Col>
                <Button
                  size="sm"
                  className="btn"
                  color="success"
                  onClick={handleManualAdd}
                  disabled={
                    !manualInput?.articulosNombre ||
                    !manualInput?.idColor ||
                    !manualInput?.idTalla ||
                    !manualInput?.cantidad
                  }
                  tabindex="-1"
                >
                  Agregar
                </Button>
              </Col>
            </Row>
          </>

          <br />
          <hr />

          <div>
            {Object.entries(
              inputFields
                .filter((field) => field.articulosNombre && field.articulos)
                .reduce((acc, field) => {
                  const key = `${field.articulosNombre}`;
                  if (!acc[key]) {
                    acc[key] = {
                      articuloInfo: {
                        articulosNombre: field.articulosNombre,
                        articulos: field.articulos,
                        availableTallas: Array.from(
                          new Set(
                            inputFields
                              .filter(
                                (f) =>
                                  f.articulosNombre === field.articulosNombre
                              )
                              .map((f) => f.tallaNombre)
                              .filter(Boolean)
                              .sort((a, b) => {
                                return (
                                  customSizeOrder.indexOf(a) - customSizeOrder.indexOf(b)
                                );
                              })
                          )
                        ),
                      },
                      colorGroups: [],
                    };
                  }

                  const existingColorIndex = acc[key].colorGroups.findIndex(
                    (item) => item.idColor === field.idColor
                  );

                  if (existingColorIndex === -1) {
                    acc[key].colorGroups.push({
                      id: field.id,
                      articulos: field.articulos,
                      articulosNombre: field.articulosNombre,
                      idColor: field.idColor,
                      colorNombre: field.colorNombre,
                      colores: field.colores,
                      precio: field.precio,
                      quantities: {
                        [field.tallaNombre]: {
                          cantidad: field.cantidad,
                          id: field.id,
                        },
                      },
                      total: field.cantidad * field.precio,
                    });
                  } else {
                    acc[key].colorGroups[existingColorIndex].quantities[
                      field.tallaNombre
                    ] = {
                      cantidad: field.cantidad,
                      id: field.id,
                    };
                    acc[key].colorGroups[existingColorIndex].total +=
                      field.cantidad * field.precio;
                  }
                  return acc;
                }, {})
            ).map(([articuloNombre, { articuloInfo, colorGroups }]) => {
              // Calculate totals for this article
              const articleTotals = colorGroups.reduce(
                (totals, group) => {
                  const quantitySum = Object.values(group.quantities).reduce(
                    (sum, q) => sum + (parseFloat(q.cantidad) || 0),
                    0
                  );
                  const priceSum = Object.values(group.quantities).reduce(
                    (sum, q) =>
                      sum + (parseFloat(q.cantidad) || 0) * group.precio,
                    0
                  );

                  return {
                    items: totals.items + quantitySum,
                    price: totals.price + priceSum,
                    singlePrice: group.precio,
                  };
                },
                { items: 0, price: 0 }
              );

              return (
                <div key={articuloNombre} className="mb-8">
                  <div className="d-flex align-items-center border-t-2 border-gray-200 pt-2 pb-2 bg-gray-50">
                    <div className="d-flex align-items-center">
                      <Button
                        size="sm"
                        className="btn mr-3"
                        color="info"
                        onClick={() =>
                          setExpandedTables((prev) => ({
                            ...prev,
                            [articuloNombre]: !prev[articuloNombre],
                          }))
                        }
                      >
                        <i
                          className={`fas fa-chevron-${
                            expandedTables[articuloNombre] ? "up" : "down"
                          }`}
                        ></i>
                      </Button>
                      <h4 className="negrita mb-0 mr-4">{articuloNombre}</h4>
                    </div>
                    {!expandedTables[articuloNombre] && (
                      <div className="d-flex align-items-center">
                        <span
                          className="mr-4 text-dark"
                          style={{ fontSize: "18px" }}
                        >
                          <strong style={{ fontSize: "18px" }}>Piezas:</strong>{" "}
                          {articleTotals.items}
                        </span>
                        <span
                          className="mr-4 text-dark"
                          style={{ fontSize: "18px" }}
                        >
                          <strong style={{ fontSize: "18px" }}>Precio:</strong>{" "}
                          $
                          {articleTotals.singlePrice.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                        <span
                          className="text-dark"
                          style={{ fontSize: "18px" }}
                        >
                          <strong style={{ fontSize: "18px" }}>Total:</strong> $
                          {articleTotals.price.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    )}
                  </div>

                  {expandedTables[articuloNombre] && (
                    <Table borderless>
                      <thead>
                        <tr>
                          <th>Articulo</th>
                          <th>Color</th>
                          {articuloInfo.availableTallas.map((talla) => (
                            <th key={talla} style={{ maxWidth: "60px" }}>
                              {talla}
                            </th>
                          ))}
                          <th style={{ maxWidth: "60px" }}>Precio MEX</th>
                          <th style={{ maxWidth: "80px" }}>Total</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {colorGroups.map((group) => (
                          <tr key={`${group.id}-${group.idColor}`}>
                            {/* Your existing row content */}
                            <td>
                              <Input
                                name="articulo"
                                type="string"
                                placeholder="Articulo"
                                value={group.articulosNombre}
                                disabled
                              />
                            </td>
                            <td>
                              {/* Deshabilitado: cambiar el color aqui solo
                                  modificaba la PRIMERA fila del grupo (las
                                  demas tallas se quedaban con el color viejo)
                                  y sin actualizar colorNombre, generando
                                  grupos mezclados. Para cambiar de color:
                                  quitar el renglon y volver a agregar. */}
                              <Input
                                name="idColor"
                                type="select"
                                value={group.idColor}
                                disabled
                                title="Para cambiar el color, elimina el renglón y vuelve a agregarlo."
                              >
                                <option value="">Selecciona</option>
                                {group.colores?.map((a) => (
                                  <option key={a._id} value={a._id}>
                                    {a.name}
                                  </option>
                                ))}
                              </Input>
                            </td>
                            {articuloInfo.availableTallas.map((talla) => (
                              <td key={talla} style={{ maxWidth: "60px" }}>
                                {/* Sin fila propia la celda va DESHABILITADA.
                                    El fallback anterior (|| group.id) escribia
                                    la cantidad en OTRA talla del mismo color
                                    sin que se viera donde se tecleo. Para dar
                                    de alta una talla que no esta, usar
                                    "Agregar Pieza". */}
                                <Input
                                  name="cantidad"
                                  type="number"
                                  min="0"
                                  step="any"
                                  value={group.quantities[talla]?.cantidad || 0}
                                  disabled={!group.quantities[talla]}
                                  title={
                                    !group.quantities[talla]
                                      ? "Este color no maneja esta talla en su proporción. Usa 'Agregar Pieza' para capturarla."
                                      : undefined
                                  }
                                  onChange={(event) => {
                                    const rowId = group.quantities[talla]?.id;
                                    if (rowId) handleChangeInputCantidad(rowId, event);
                                  }}
                                />
                              </td>
                            ))}

                            <td style={{ maxWidth: "60px" }}>
                              <Input
                                name="precio"
                                type="number"
                                min="0"
                                step="any"
                                placeholder="Precio"
                                value={group.precio}
                                required
                                onChange={(event) =>
                                  handleChangeInput(group.id, event)
                                }
                              />
                            </td>
                            <td style={{ maxWidth: "80px" }}>
                              <Input
                                name="total"
                                type="number"
                                min="0"
                                step="any"
                                placeholder="total"
                                value={group.total}
                                disabled
                              />
                            </td>
                            <td>
                              <Button
                                size="sm"
                                className="btn"
                                color="danger"
                                disabled={inputFields.length === 1}
                                onClick={() => handleRemoveFields(group.id)}
                                tabindex="-1"
                              >
                                <i className="fas fa-minus"></i>
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </div>
              );
            })}
          </div>
          {/* </Form> */}
          {/* Termina Tabla Articulos */}

          <br />
          <Row className="align-items-center mt-3">
            <Col xs={3} className="text-dark" style={{ fontSize: "20px" }}>
              <span className="fw-bold">
                <b>Total Piezas:</b>{" "}
              </span>
              <span>
                {new Intl.NumberFormat("en-US").format(total_cantidad)}
              </span>
            </Col>

            <Col xs={3} className="text-dark" style={{ fontSize: "20px" }}>
              <span className="fw-bold">
                <b>Total:</b>{" "}
              </span>
              <span>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "MEX",
                  maximumFractionDigits: 2,
                }).format(total_general)}
              </span>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={1}>
              {validaBoton ? (
                <Button
                  type="submit"
                  className="btn btn-success"
                  tabindex="-1"
                  onClick={savePedido}
                >
                  Guardar
                </Button>
              ) : (
                <Button type="submit" className="btn btn-success" disabled>
                  Guardar
                </Button>
              )}
            </Col>
            <Col md={1}>
              <Button
                href="/ListadoCompras"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
          </Row>
          {/* </Form> */}
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>

          <Modal
            size="sm"
            isOpen={modalCambiaPrecio}
            toggle={toggleCambiaPrecio}
          >
            <ModalHeader toggle={toggleCambiaPrecio}>
              <h4>Autorizar Precio</h4>
            </ModalHeader>
            <ModalBody>
              {mailAutEnviado === false ? (
                <Col>
                  <Button
                    type="submit"
                    className="btn btn-success"
                    onClick={(e) => solicitarAut()}
                  >
                    Solicitar Autorizacion
                  </Button>
                </Col>
              ) : (
                <>
                  <Input
                    bsSize="sm"
                    type="password"
                    placeholder="Password"
                    value={password}
                    required
                    onChange={(event) => setPassword(event.target.value)}
                  />
                  <br />
                  <Row>
                    <Col>
                      <Button
                        type="submit"
                        className="btn btn-success"
                        onClick={(e) => autorizaCambio()}
                      >
                        Autorizar
                      </Button>
                    </Col>

                    <Col>
                      <Button
                        type="submit"
                        className="btn btn-success"
                        onClick={(e) => solicitarAut()}
                      >
                        Reenviar Solicitud
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ComprasCreate;
